import React, { useState } from "react";
import "../../styles/orderlist.css";
import { motion, AnimatePresence } from "framer-motion";
import { MdClose } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import StarRating from "./starRating";
import { toast } from "react-toastify";
import { OrderApi } from "api/order.api";
import AnalyticsService from "services/analytics.service";
import { EVENT_NAME } from "utils/constants";
import { TimeUtils } from "utils/time.utils";

export default function OrderRateFeedback({ order, onSubmit }) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  const submitReview = async (orderId) => {
    if (!rating) {
      toast.error("Please select a rating");
      return;
    }

    try {
      await OrderApi.rateOrder(orderId, { rating, feedback });
      AnalyticsService.trackEvent(EVENT_NAME.ORDER_RATE_FEEDBACK_SUBMITTED, {
        orderId,
        rating,
        feedback,
        totalAmount: order.totalAmount,
        orderCreatedAt: order.createdAt,
        orderDeliveredAt: order.deliveredAt,
        deliveryFee: order.deliveryFee,
        orderNumber: order.orderNumber,
        areaId: order.areaId,
        deliveryTime: TimeUtils.timeDifferenceInMinutes(order.deliveredAt, order.createdAt),
      });
      toast.success("Review submitted successfully!");
      onSubmit();
    } catch (error) {
      toast.error(error.message);
    }

    // Close the form after submission
    setRating(0);
    setFeedback("");
  };


  const openReviewForm = (orderId) => {
    setRating(0);
    setFeedback("");
  };

  return (
    <div className="review-section">
      {order.orderFeedback ? (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          className="review-submitted"
        >
          <div
            className="submitted-rating"
            style={{ display: "flex", alignItems: "center", gap: "2px" }}
          >
            Rating:{" "}
            {[...Array(5)].map((_, i) => (
              <FaStar
                key={i}
                color={i < order.orderFeedback.rating ? "#ffc107" : "#e4e5e9"}
                size={16}
              />
            ))}
          </div>
          {order.orderFeedback.feedback && (
            <p className="submitted-review">{order.orderFeedback.feedback}</p>
          )}
        </motion.div>
      ) : (
        <AnimatePresence>
          {!order.orderFeedback ? (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="review-form-container"
            >
              <div className="review-form-header">
                <h3>Rate Your Order</h3>
              {/*   <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="close-review-button"
                  onClick={() => closeReviewForm(order.id)}
                >
                  <MdClose size={18} />
                </motion.button> */}
              </div>
              <div className="review-form">
                <div className="rating-input">
                  <label>Your Rating:</label>
                  <StarRating rating={rating} setRating={setRating} />
                </div>
                <div className="review-input">
                  <label>Your Review (optional):</label>
                  <textarea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="Share your experience..."
                  />
                </div>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="submit-review-button"
                  onClick={() => submitReview(order.id)}
                >
                  Submit Review
                </motion.button>
              </div>
            </motion.div>
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="review-prompt"
            >
              <button
                className="review-button"
                onClick={() => openReviewForm(order.id)}
              >
                Rate & Review Order
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
}
